import script from "./DiDiAiPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./DiDiAiPanel.vue?vue&type=script&setup=true&lang=js"

import "./DiDiAiPanel.vue?vue&type=style&index=0&id=4dec988f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dec988f"]])

export default __exports__